import React, { useState, useEffect } from 'react'
import { FetchFromApi } from '../utils/FetchFromApi'
import { Videos, ChannelCard } from './'
import { useParams } from 'react-router-dom'
import { Box } from "@mui/material";
const ChannelDetail = () => {
  const [channelDetails, setChannelDetails] = useState([])
  const [videosDetails, setVideosDetails] = useState([])
  const [loading, setLoading] = useState(true);
  const { id } = useParams()
  useEffect(() => {
    FetchFromApi(`channels?part="snippet&id=${id}`)
      .then((data) => {
        setChannelDetails(data.items[0])
        setLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setLoading(false)
      })


      FetchFromApi(`search?channelId=${id}&part=snippet&order=date`)
      .then((data) => {
        setVideosDetails(data.items)
      })
      .catch((err) => {
        console.log(err)
      })

  }, [id])
  if (loading) {
    return <h1 style={{ color: "red", textAlign: "center" }} >Loading..</h1>
  }
  console.log(channelDetails);
  return (
    <>
      <Box minHeight="95vh">
        <Box>
          <div style={{
            height: '300px',
            background: 'linear-gradient(90deg, rgba(0,238,247,1) 0%, rgba(206,3,184,1) 100%, rgba(0,212,255,1) 100%)',
            zIndex: 10,
          }} />
          <ChannelCard channelDetail={channelDetails} marginTop="-93px" />
        </Box>
        <Box p={2} display="flex">
          <Box sx={{ mr: { sm: '100px' } }} />
            <Videos videos={videosDetails}/>
        </Box>
      </Box>

    </>
  )
}

export default ChannelDetail
